import PropTypes from 'prop-types';

const propTypes = {
  url: PropTypes.string.isRequired,
  children: PropTypes.string.isRequired,
};

export default function TrainerSocialAction({ url, children }) {
  return (
    <a
      href={url}
      className="flex lg:inline-flex items-center justify-center space-x-2 rounded-full bg-gray-900 hover:bg-gray-700 focus:ring-4 focus:ring-gray-600 focus:ring-opacity-20 focus:bg-gray-900 text-white focus:outline-none px-5 py-2 text-sm font-semibold shadow leading-5 text-center whitespace-nowrap"
    >
      {children}
    </a>
  );
}

TrainerSocialAction.propTypes = propTypes;
